import './HomeNewsItem.scss';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

function HomeNewsItem(article) {

    const to = useMemo(() => article.news_id ? `/newsroom/${article.news_id}` : article.link, [article])

    return <Link className={`home-news-item`}
        style={{...article.style}}
        to={to}
    >
        <img className='home-news-item-image' src={article.img_url} alt={article.title} />
        <div className='home-news-item-content'>
            <div className='home-news-item-category'>{article.category}</div>
            <div className='home-news-item-title'>{article.title}</div>
            <div className='home-news-item-hashtag-container'>
                {article.hashtag.split(',').map((item, index) => <span key={`hashtag_${index}`} className='home-news-item-hashtag'>#{item.trim()}</span>)}
            </div>
        </div>
    </Link>
}

export default HomeNewsItem;
